import tippy from 'tippy.js';

export class Dropdown {
    constructor() {
        this.init();
    }

    init() {
        tippy.setDefaultProps({
            offset: [0, 15],
            allowHTML: true,
            interactive: true,
            trigger: 'click',
            placement: 'bottom-end',
            maxWidth: 200
		});

        tippy('.dropdown-toggle', {
            content(reference) {
                const id = reference.getAttribute('data-dropdown');
                const template = document.getElementById(id);
                return template.innerHTML;
            },
        });
    }
} 